<template>
  <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading" style="overflow: hidden;">
    <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
      <el-col class="flex-box al-c" :span="6">
        <el-button type="primary" @click="initPage">查询</el-button>
        <el-button type="primary" @click="addFileShow">添加附件</el-button>
        <el-button type="primary" :disabled="!this.checkData.length" @click="deleteFn()">批量删除</el-button>
      </el-col>
    </Sift>
    
    <div class="table-con">
      <el-table class="w100 mt20 table to-use" header-row-class-name="table-head" @selection-change="checkedFn" row-class-name="cu-p" stripe :data="list" height="100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">
            {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="fileName" label="附件名称"></el-table-column>
        <el-table-column align="center" prop="type" label="附件类型" width="80px"></el-table-column>
        <el-table-column align="center" prop="createUser" label="上传人" width="100px"></el-table-column>
        <el-table-column align="center" label="上传时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="refuseIP" label="操作" width="160px">
          <template slot-scope="scope">
            <span class="info" @click="download(scope.row)">下载附件</span>
            <span class="delete" @click="deleteFn(scope.row)">删 除</span>
            <a v-show="false" ref="url" :href="url" target="_blank">1</a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    
    <AddFile ref="addFile"></AddFile>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sift from "@/components/sift/Sift";
import AddFile from "@/components/management/file/AddFile";

export default {
  name: "File",
  components: {
    Sift,
    AddFile
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      checkData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      downUrl: this.$http.defaults.baseURL, // 下载地址
      url: ""
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {},
  mounted() {
    this.fetchSiftData()
  },
  destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData() {
      this.loading = true;

      // 查询条件 file/getTitleData
      this.$http.get( "/file/getTitleData")
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.siftData = data.resData;

          this.$nextTick(() => {
            this.initPage();
          });
        } else {
          this.loading = false;
        }
      })
      .catch(() => {
        this.loading = false;
      })
    },

    // 获取列表
    getListFn () {
      let data = this.$refs.needSift.getValue();  // 获取搜索条件的值
      data.pageNum = this.pageNum;
      data.pageSize = this.pageSize;
      data.createUser = "";

      this.$http.post( "/file/findPage", data )
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.list = data.resData.list;
          this.total = data.resData.total;
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      })
    },

    // 下载
    download(row) {
      this.loading = true;

      this.$http.get( "/bigFile/getUrl/" + row.id)
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.url = this.downUrl + data.resData + "?token=" + this.userToken;
          this.$nextTick( () => {
            this.$refs.url.click();
          })
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },

    // 删除
    deleteFn (arr) {
      let ids = [];
      let name = "";

      if (arr) {  // 单个删除
        ids.push(arr.id);
        name = arr.fileName + " 文件";
      } else { // 批量删除
        name = "所选中的文件";
        ids = this.checkData.map( val => { return val.id })
      }

      this.$confirm( "是否确定删除 " + name + " ?", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        // 删除接口
        if (arr) {  // 单个删除
          this.deleteOne(ids);
        } else { // 批量删除
          this.deleteMore(ids);
        }
      }).catch(() => {
        this.$message({ type: "info", message: "已取消删除" });
      });
    },

    // 默认页面数据
    initPage() {
      this.pageNum = 1;
      this.getListFn();
    },

    // 条数
    changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage(value) {
      this.pageNum = value;
      this.getListFn();
    },
    // 显示上传弹框
    addFileShow () {
      let data = {
        limit: 5, // 单次上传最大文件数
        title: "请选择上传文件"  // 弹框标题
      };
      this.$refs["addFile"].showBox(data);
    },
    // 多选
    checkedFn (val) {
      this.checkData = val;
    },
    // 单个删除
    deleteOne (id) {
      this.$http.delete( "/file/removeFile?id=" + id.join(","))
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.$message.success(data.resMsg);
          this.initPage();
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },
    // 批量删除
    deleteMore (ids) {
      this.$http.delete( "/file/deleteFileByButton", {data: {ids: ids}})
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.$message.success(data.resMsg);
          this.initPage();
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
  .table-con {
    height: calc(100vh - 310px);
  }
  
  .to-use {
    width: 100%;
  }

  .to-use span {
    padding: 0 8px;
    display: inline-block;
  }

  .to-use .info {
    color: #409EFF;
  }

  .to-use .delete {
    color: #cdcdcd;
  }

  .to-use .info:hover {
    color: #336ab1;
  }

  .to-use .delete:hover {
    color: #606266;
  }
</style>
